import { render } from "./CommunityVx.vue?vue&type=template&id=7fbe8580&scoped=true"
import script from "./CommunityVx.vue?vue&type=script&lang=js"
export * from "./CommunityVx.vue?vue&type=script&lang=js"

import "./CommunityVx.vue?vue&type=style&index=0&id=7fbe8580&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbe8580"]])

export default __exports__